import {
  getAllAttendanceShiftFailure,
  getAllAttendanceShiftSuccess,
  addNewAttendanceShiftFailure,
  addNewAttendanceShiftSuccess,
  editAttendanceShiftFailure,
  editAttendanceShiftSuccess,
  deleteAttendanceShiftFailure,
  deleteAttendanceShiftSuccess
} from "../constants/attendanceShift";

const initialState = {
  isProcessing: false,
  isError: false,
  addNewShiftError: false,
  editExistingShiftError: false,
  deleteExistingShiftError: false,
  data: {
    object: [],
    totalCount: 0
  }
};

function handleReducer(state = initialState, action) {
  switch (action.type) {
    case getAllAttendanceShiftFailure:
      return { ...state, isError: true };

    case getAllAttendanceShiftSuccess:
      return { ...state, data: action.payload };

    case addNewAttendanceShiftSuccess:
      return {
        ...state,
        data: {
          ...state.data,
          object: [...(state.data.object || []), action.payload],
          totalCount: (state.data.totalCount || 0) + 1,
        },
      };

    case addNewAttendanceShiftFailure:
      return { ...state, addNewShiftError: true };

    case editAttendanceShiftSuccess:
      return {
        ...state,
        data: {
          ...state.data,
          object: state.data.object.map((attendance) =>
            attendance.ambulanceId === action.payload.ambulanceId &&
            attendance.employeeId === action.payload.employeeId &&
            attendance.date.join("-") === action.payload.date
              ? { ...attendance, ...action.payload }
              : attendance
          ),
        },
        editExistingShiftError: false
      };

    case editAttendanceShiftFailure:
      return { ...state, editExistingShiftError: true };

    case deleteAttendanceShiftSuccess:
      return {
        ...state,
        data: {
          ...state.data,
          object: state.data.object.filter((attendance) =>
            attendance.ambulanceId !== action.payload.ambulanceId ||
            attendance.employeeId !== action.payload.employeeId ||
            attendance.date.join("-") !== action.payload.date
          ),
          totalCount: Math.max((state.data.totalCount || 1) - 1, 0),
        },
        deleteExistingShiftError: false
      };

    case deleteAttendanceShiftFailure:
      return { ...state, deleteExistingShiftError: true };

    default:
      return state;
  }
}

export function attendanceShiftReducer(state, action) {
  return handleReducer(state, action);
}
